import { request } from '@synergy/api';

import { BaseState } from './models/base-state';

export class CommonApi {
    constructor(protected baseUrl: string) {}

    public async getBaseState(): Promise<BaseState | null> {
        const response = await request.get(`${this.baseUrl}/`);

        if (!response) {
            return null;
        }

        const account = response.data.account;
        const lastCheckedDate = account.lastCheckedDate && new Date(account.lastCheckedDate);
        const lastCheckedExpirationThresholdInDays = response.data.lastCheckedExpirationThresholdInDays;

        let accountNeedsToBeChecked = false;

        if (lastCheckedExpirationThresholdInDays) {
            // get the next check date with current date - threshold from backend
            const nextCheckDate = new Date();
            nextCheckDate.setDate(nextCheckDate.getDate() - lastCheckedExpirationThresholdInDays);

            // getTime() to check dates if different formats occur
            if (!lastCheckedDate || lastCheckedDate.getTime() < nextCheckDate.getTime()) {
                accountNeedsToBeChecked = true;
            }
        }

        return {
            account: {
                ...account,
                lastCheckedDate,
                lastCheckedExpirationThresholdInDays,
                accountNeedsToBeChecked,
            },
            accounts: response.data.accounts,
            currentLocale: response.data.locale,
            supportedLocales: response.data.supportedLocales,
            user: response.data.user,
            supportedCurrencies: response.data.supportedCurrencies,
            currency: response.data.currency,
            settings: {
                mediaBaseUrl: response.data.mediaBaseUrl,
                isImpersonator: response.data.isImpersonator,
                isPoolAccount: response.data.isPoolAccount,
            },
        };
    }
}
